module.exports = __webpack_public_path__ + "static/media/Espectrofotometro.17ffae5d.png";